export default {"src":"/_next/static/media/laptop.22a524ef.svg","height":76,"width":76};